import * as React from 'react';
import { Space, Button, Icon, Typography } from '@sravni/react-design-system';
import { Mail, Phone, Telegram, WhatsApp } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils/lib/hooks';
import { formatPhone } from '../../../helpers/formatPhone.js';
import modules_7ff94741 from '../styles/Support.module.less.js';
import { SupportChannelType } from '../types/Support.types.js';

const { Text } = Typography;
const createHrefByChannel = (channel) => {
    const { type, link } = channel;
    switch (type) {
        case SupportChannelType.PHONE:
            return `tel:${link}`;
        case SupportChannelType.EMAIL:
            return `mailto:${link}`;
        case SupportChannelType.WHATSAPP:
        case SupportChannelType.TELEGRAM:
        default:
            return link;
    }
};
const createIconByChannel = (channel) => {
    const { type } = channel;
    switch (type) {
        case SupportChannelType.WHATSAPP:
            return WhatsApp;
        case SupportChannelType.TELEGRAM:
            return Telegram;
        case SupportChannelType.PHONE:
            return Phone;
        case SupportChannelType.EMAIL:
        default:
            return Mail;
    }
};
/**
 * @description Support.
 *
 * @component
 * @example
 * ```jsx
 * <Support />
 * ```
 */
const Support = (props) => {
    const { phone, supportStart, supportEnd, channels } = props;
    const isEnabledChannels = channels.length > 0;
    const cx = useStyles(modules_7ff94741);
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { className: cx('support-title', 'h-mb-4') }, "\u0421\u043B\u0443\u0436\u0431\u0430 \u0437\u0430\u0431\u043E\u0442\u044B \u043E \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u0445"),
        React.createElement(Text, { className: "h-mb-4", size: 20, strong: true }, formatPhone(phone)),
        React.createElement(Text, { className: "h-color-D60 h-mb-36", size: 12 }, `Ежедневно с ${supportStart} до ${supportEnd} по МСК`),
        isEnabledChannels ? (React.createElement(React.Fragment, null,
            React.createElement(Text, { className: "h-mb-12" }, "\u041E\u0442\u0432\u0435\u0442\u0438\u043C \u043D\u0430 \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B"),
            React.createElement(Space, { size: 8, align: "center", className: cx('support-help') }, channels.map((channel) => {
                const id = `${channel.type}_${channel.link}`;
                const href = createHrefByChannel(channel);
                const IconChannel = createIconByChannel(channel);
                return (React.createElement("a", { href: href, key: id },
                    React.createElement(Button, { "aria-label": channel.type },
                        React.createElement(Icon, { icon: React.createElement(IconChannel, { className: "h-color-D30" }) }))));
            })))) : null));
};
Support.defaultProps = {};

export { Support as default };
//# sourceMappingURL=Support.js.map
